import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

// Cierra la sesión del panel tras un periodo de INACTIVIDAD (por defecto 30 min).
// La última actividad se guarda en localStorage para que todas las pestañas la
// compartan: si el usuario está activo en CUALQUIER pestaña, ninguna cierra la
// sesión (evita desloguear a alguien que sigue trabajando en otra pestaña).
// Antes eran 5 min: un agente hablando >5 min sin tocar el mouse se deslogueaba
// en plena llamada. El softphone además escribe `pbx-on-call` mientras hay una
// llamada activa para que este timer NUNCA la corte.
const AKEY = 'pbx-last-activity';
const CALLKEY = 'pbx-on-call';
const DEFAULT_IDLE_MS = 30 * 60 * 1000;

export default function useIdleLogout(idleMs = DEFAULT_IDLE_MS) {
  const token = useAuthStore((s) => s.token);
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    if (!token) return undefined; // solo con sesión iniciada

    const bump = () => {
      try { localStorage.setItem(AKEY, String(Date.now())); } catch (_) {}
    };
    // Eventos que cuentan como actividad del usuario.
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'wheel', 'visibilitychange'];
    events.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    bump(); // marcar actividad al montar

    let done = false;
    const endSession = async () => {
      if (done) return;
      done = true;
      clearInterval(check);
      events.forEach((e) => window.removeEventListener(e, bump));
      try { await logout(); } catch (_) {}
      try { localStorage.removeItem(AKEY); } catch (_) {}
      // Forzar el paso a la pantalla de login aunque el router no reaccione.
      if (window.location.pathname !== '/login') window.location.href = '/login';
    };

    // Revisar periódicamente; barato y robusto ante suspensión de la pestaña.
    const check = setInterval(() => {
      // Nunca cerrar la sesión mientras haya una llamada activa (el softphone
      // pone `pbx-on-call` = timestamp; se ignora si quedó viejo por un crash).
      const onCall = parseInt(localStorage.getItem(CALLKEY) || '0', 10);
      if (onCall && Date.now() - onCall < 4 * 60 * 60 * 1000) return;
      const last = parseInt(localStorage.getItem(AKEY) || '0', 10) || Date.now();
      if (Date.now() - last >= idleMs) endSession();
    }, 15000);

    return () => {
      clearInterval(check);
      events.forEach((e) => window.removeEventListener(e, bump));
    };
  }, [token, logout, idleMs]);
}
